module.exports = __webpack_public_path__ + "static/media/logo-afterpay.8b538b24.svg";